import { createContext, useContext } from 'react'

/**
 * Closes the phone navigation drawer. The shell provides it; anything inside the drawer
 * that opens a dialog calls it first, so the dialog does not open on top of a drawer the
 * person then has to dismiss separately. Outside a shell, and on desktop, it does nothing.
 */
export const CloseNavContext = createContext<() => void>(() => undefined)

export const useCloseNav = (): (() => void) => useContext(CloseNavContext)
